import {Component, computed, input} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';
import {
  ChevronRightIcon,
  GraduationCapIcon,
  LucideAngularModule,
  MilestoneIcon,
  SquareUserRoundIcon,
  TriangleAlertIcon
} from 'lucide-angular';
import {RouteGenerator} from '@core/route-generator';
import {ActivityDTO, ActivityState} from '@domain/activity/activity.dto';
import {UI_ROUTES} from '@core/ui.routes';
import {ActivityTypeIconComponent} from '@domain/activity/component/activity-type-icon/activity-type-icon.component';
import {
  ActivityStateBadgeComponent
} from '@domain/activity/component/activity-state-badge/activity-state-badge.component';
import {ActivityScheduleUtil} from '@domain/activity/schedule/activity-schedule.util';
import {ActivityUtil} from '@domain/activity/activity.util';
import {
  SchedulePreviewComponent
} from '@domain/activity/schedule/component/schedule-preview/schedule-preview.component';

@Component({
  selector: 'app-activity-preview',
  imports: [
    TranslocoDirective,
    RouterLink,
    LucideAngularModule,
    ActivityTypeIconComponent,
    ActivityStateBadgeComponent,
    SchedulePreviewComponent
  ],
  templateUrl: './activity-preview.component.html',
  styleUrl: './activity-preview.component.scss'
})
export class ActivityPreviewComponent {
  public readonly item = input.required<ActivityDTO>();
  public readonly isPublic = input.required<boolean>();
  public readonly showState = input(false);
  public readonly showDistance = input(false);
  public readonly showHost = input(false);
  public readonly showDetails = input(false);

  public readonly isDraft = computed(() => this.item().state === ActivityState.Draft);

  public readonly icons = {
    warning: TriangleAlertIcon,
    rightChevron: ChevronRightIcon,
    map: MilestoneIcon,
    age: SquareUserRoundIcon,
    supervisor: GraduationCapIcon,
  };





  public readonly schedules = computed(() => this.item()?.schedules ?? []);
  private readonly activeSchedules = computed(() => this.schedules().filter(s => !ActivityScheduleUtil.isFinished(s)))
  private readonly additionalSchedules = computed(() => (this.activeSchedules().length || 1) - 1);
  public readonly additionalSchedulesString = computed(() => {
    const nb = this.additionalSchedules();
    return nb === 0
      ? null
      : `+${nb} autre${nb > 1 ? 's' : ''}`;
  });
  public readonly nextSchedule = computed(() => ActivityScheduleUtil.getNextSchedule(this.activeSchedules()));

  public detailsUrl = computed(
    () => {
      if (!this.isPublic()) {
        return RouteGenerator.abs(UI_ROUTES.account.activity.home, {activityId: this.item().id});
      }
      const slug = ActivityUtil.getSlug(this.item());
      return slug
        ? RouteGenerator.abs(UI_ROUTES.public.activity.home, {slug: slug})
        : null;
    }
  );

  private readonly distance = computed(() => {
    const allDistances = (
      this.item()?.schedules
        ?.filter(s => !!s?.venue?.distance)
        ?.map(s => s.venue?.distance!)
    ) ?? [];
    if (allDistances.length === 0) {
      return null;
    }
    const minDistance = Math.min(... allDistances);
    if (minDistance > 1000) {
      return (minDistance / 1000).toFixed(1) + ' km';
    }
    return '< 1 km'
  });


}
